<template>
  <Container>
    <HeroCard
      :heading="t('jc.view.game.hero.title')"
      :paragraph="t('jc.view.game.hero.text')"
      :label="t('jc.view.game.hero.button.label')"
      :icon="'play'"
      :to="config.public.youtubeTrailerUrl"
      :image="{
        src: 'images/nature/foggy_hill.png',
        alt: t('jc.view.game.hero.banner.alt'),
      }"
    />
  </Container>

  <Container>
    <GameCard
      :heading="t('jc.view.game.dungeon-explorer.title')"
      :paragraph="t('jc.view.game.dungeon-explorer.text')"
      :image="{
        src: 'images/view/game/index/dungeon_background.png',
        alt: t('jc.view.game.dungeon-explorer.banner.alt'),
      }"
      :float="{
        src: 'images/skin_renders/compositions/fight_mob.png',
        alt: t('jc.view.game.dungeon-explorer.float.alt'),
      }"
      :to="localePath({
        name: 'game-dungeon-explorer',
      })"
      :leaderboard="localePath({
        name: 'game-dungeon-explorer-leaderboard',
      })"
      :guide="localePath({
        name: 'game-dungeon-explorer-guide'
      })"
    />
  </Container>

  <Container>
    <ContentCard
      :heading="t('jc.view.game.comingSoon.title')"
      :paragraph="t('jc.view.game.comingSoon.text')"
    >
      <IconSection
        :sections="comingSoonSections"
      />
    </ContentCard>
  </Container>

  <Container>
    <ContentCard
      :heading="t('jc.view.game.rules.title')"
      :paragraph="t('jc.view.game.rules.text')"
    >
      <div class="flex">
        <NuxtLink
          :to="localePath({ name: 'rules' })"
          class="bg-primary hover:bg-primary-highlighted active:bg-primary-selected text-white
            text-center rounded py-2 px-4 flex flex-row gap-3 font-semibold mr-auto"
        >
          <font-awesome-icon
            :icon="['fas', 'scale-balanced']"
            fixed-width
            size="lg"
          />
          <span>{{ t('jc.view.game.rules.button.label') }}</span>
        </NuxtLink>
      </div>
    </ContentCard>
  </Container>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const { t } = useI18n()
const localePath = useLocalePath()
const config = useRuntimeConfig()

definePageMeta({
  nameKey: 'game',
  head: {
    imageUrl: '/images/view/game/meta_preview.png',
  },
})

const comingSoonSections = [
  {
    icon: 'house-flag',
    title: t('jc.view.game.comingSoon.section.journey.title'),
    text: t('jc.view.game.comingSoon.section.journey.text'),
  },
  {
    icon: 'pen-paintbrush',
    title: t('jc.view.game.comingSoon.section.creative.title'),
    text: t('jc.view.game.comingSoon.section.creative.text'),
  },
  {
    icon: 'user-crown',
    title: t('jc.view.game.comingSoon.section.rpg.title'),
    text: t('jc.view.game.comingSoon.section.rpg.text'),
  },
  {
    icon: 'game-console-handheld',
    title: t('jc.view.game.comingSoon.section.minigames.title'),
    text: t('jc.view.game.comingSoon.section.minigames.text'),
  },
]
</script>
